import type { StateCreator } from 'zustand';
import type { StoreType, AuditSlice } from '@/types/store';

export const createAuditSlice: StateCreator<StoreType, [], [], AuditSlice> = () => ({
  trail: [],
});
